enum PageComponentName {
  HomeRedirect = 'HomeRedirectPage',
  NotFound = 'NotFoundPage',
  Preferences = 'PreferencesPage',
  Unsubscribe = 'UnsubscribePage',
}

export default PageComponentName;
